
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"11","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M14.5 2.483c-1.933 0-3.806.31-5.558.894v3.849c0 .496-.278.918-.677 1.117a14.24 14.24 0 00-3.226 2.297 1.12 1.12 0 01-.81.36c-.362 0-.664-.149-.882-.373L.35 7.55a1.247 1.247 0 01-.35-.87c0-.347.133-.658.35-.881C4.036 2.198 9.014 0 14.5 0c5.486 0 10.464 2.198 14.15 5.798.217.223.35.534.35.881 0 .336-.133.646-.35.87l-2.997 3.078c-.218.224-.52.373-.882.373-.302 0-.604-.137-.822-.36a13.907 13.907 0 00-3.214-2.297 1.24 1.24 0 01-.677-1.117V3.377a17.576 17.576 0 00-5.558-.894z","fill":"#E53935"}})])
          )
        }
      }
    